import { render } from "./QandCManagement.vue?vue&type=template&id=2be66426&scoped=true"
import script from "./QandCManagement.vue?vue&type=script&lang=js"
export * from "./QandCManagement.vue?vue&type=script&lang=js"

import "./QandCManagement.vue?vue&type=style&index=0&id=2be66426&scoped=true&lang=css"

import exportComponent from "/Users/thanaphon/Documents/LTC/ltc-poc-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be66426"]])

export default __exports__